import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { MediaService } from '../services/http-services/media.service';

@Pipe({
  name: 'imageUrlAsync'
})
export class ImageUrlAsyncPipe implements PipeTransform {

  constructor(private mediaService: MediaService) { }

  transform(path: string | null | undefined): Observable<string | null> {
    return this.mediaService.getMediaUrl(path);
  }
}
